import Image from "next/image";
import React from "react";
import "./Loading.css";

const LoadingIllustration = () => {
  return (
    <div className="flex flex-col items-center gap-5">
      <div className="relative mt-10 h-20 w-20">
        {/* Scanning Bar */}
        <div className="animate-scan absolute -left-4 top-0 z-10 h-[3px] w-[112px] bg-[#0018F4]"></div>
        <Image
          src="/assets/resumeScore/score-loading-illustration.png"
          alt="Resume Score Loading"
          fill={true}
        />
      </div>
      <p className="font-poppins font-medium text-[#AEAEAE]">
        Scanning your Resume
      </p>
    </div>
  );
};

export default LoadingIllustration;
